import logo from 'assets/images/image.png';

const Logo = () => <img src={logo} alt="zimttech" width="200" />;

export default Logo;
